import { createSelector } from "reselect";

const selectAllTemplateTasks = (state) => state.templateTasks;

export const selectIsFetchingTemplateTasks = createSelector(
  [selectAllTemplateTasks],
  (templateTask) => templateTask.isFetchingTemplateTasks
);

export const selectTemplateTasks = createSelector(
  [selectAllTemplateTasks],
  (templateTask) => templateTask.templateTasks
);

export const selectTemplateTasksOnPage = createSelector(
  [selectAllTemplateTasks],
  (templateTask) => templateTask.templateTasksOnPage
);

export const selectSearchTemplateTasksQuery = createSelector(
  [selectAllTemplateTasks],
  (templateTask) => templateTask.searchTemplateTasksQuery
);

export const selectNumTemplateTasks = createSelector(
  [selectAllTemplateTasks],
  (templateTask) => templateTask.numTemplateTasks
);

export const selectSelectedTemplateTasks = createSelector(
  [selectAllTemplateTasks],
  (templateTask) => templateTask.selectedTemplateTasks
);
